import { tradeSalesKeys, useAppService } from "@fero/hooks";
import { useQuery } from "@tanstack/react-query";
import type { StorageLocationId } from "adl-gen/ferovinum/app/db";

export const useGetStorageLocationsSupportsDeliveryCalculationsQuery = (
  storageLocationId: StorageLocationId,
) => {
  const service = useAppService();

  return useQuery({
    queryKey: tradeSalesKeys.storageLocationSupportsDelivery(storageLocationId),
    queryFn: () =>
      service.storageLocationSupportsDeliveryCalculation(storageLocationId),
  });
};
